import api from '../api';

import { UserLocationOption, SwitchLocationSession } from './types';

const suffix = process.env.REACT_APP_ECONSENT_SUFFIX ?? '';

export async function fetchMyLocations(): Promise<UserLocationOption[]> {
  const { data } = await api.get<UserLocationOption[]>(`${suffix}/users/me/locations`);
  return Array.isArray(data) ? data : [];
}

/** Pass empty string to clear logon location (new tokens without location claim). */
export async function switchMyLocation(locationCode?: string | null): Promise<SwitchLocationSession> {
  const { data } = await api.post<SwitchLocationSession>(`${suffix}/users/me/location/switch`, {
    locationCode: locationCode ?? '',
  });
  return data;
}
